import styled from '@emotion/styled'
import { Link } from 'react-router-dom'
import { ReactComponent as List } from '../../assets/svgs/list.svg'
import { baseLayout } from '../../constants/theme'

export const AppHeader = styled('header')(({ theme, collapsed, locale }) => {
  const inset = collapsed
    ? baseLayout.sidebarCollapsedWidth
    : baseLayout.sidebarWidth
  const isRtl = locale === 'ar'

  return {
    position: 'fixed',
    top: '0',
    left: isRtl ? '0' : inset,
    right: isRtl ? inset : '0',
    zIndex: '1002',
    backgroundColor: theme.header,
    borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
    boxShadow: '0 4px 16px rgba(18, 38, 63, 0.04)',
    transition: 'left 0.3s ease-in-out, right 0.3s ease-in-out',

    [`@media (max-width: ${baseLayout.mobileBreakpoint}px)`]: {
      left: '0',
      right: '0',
    },
  }
})

export const MobileAppHeader = styled('header')(({ theme }) => ({
  position: 'fixed',
  top: 0,
  right: 0,
  left: 0,
  zIndex: 1002,
  height: baseLayout.mobileHeaderHeight,
  backgroundColor: theme.header,
  borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
  boxShadow: '0 4px 16px rgba(18, 38, 63, 0.04)',
  display: 'flex',
  flexDirection: 'column',
  '@media print': {
    display: 'none !important',
  },
}))

export const MobileHeaderTopRow = styled('div')({
  height: baseLayout.mobileHeaderTopRowHeight,
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  padding: '0 12px',
})

export const MobileHeaderBottomRow = styled('div')({
  height: baseLayout.mobileHeaderBottomRowHeight,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  padding: '0 12px 8px',
  minWidth: 0,
})

export const MobileBrandLink = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
})

export const MobileLogoImg = styled('img')({
  height: '32px',
  width: 'auto',
  maxWidth: '140px',
  objectFit: 'contain',
})

export const Navbar = styled('nav')(() => ({
  display: 'flex',
  flexPack: 'justify',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '0 auto',
  height: baseLayout.headerHeight,
  padding: `0 calc(${baseLayout.gridGutterWidth} / 2) 0 0`,
}))

const phoneQuery = `@media (max-width: ${baseLayout.mobileBreakpoint}px)`
const abovePhoneQuery = `@media (min-width: ${baseLayout.mobileBreakpoint}px)`

export const NavBarBrandBox = styled('div')(({ $collapsed, theme }) => ({
  textAlign: 'center',
  width: $collapsed
    ? `${baseLayout.sidebarCollapsedWidth} !important`
    : baseLayout.sidebarWidth,
  height: baseLayout.headerHeight,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: theme.ateneoBlue,
  transition: 'width 0.2s ease',
  position: 'fixed',
  top: '0px',
  zIndex: 99,
  [phoneQuery]: {
    width: `${baseLayout.sidebarCollapsedWidth} !important`,
    background: theme.white,
  },
}))

export const LogoNav = styled(Link)(({ $collapsed }) => ({
  lineHeight: baseLayout.headerHeight,
  backgroundColor: 'transparent',
  width: $collapsed
    ? `${baseLayout.sidebarCollapsedWidth} !important`
    : baseLayout.sidebarWidth,
  display: 'flex',
  justifyContent: 'center',
  [phoneQuery]: {
    width: `${baseLayout.sidebarCollapsedWidth} !important`,
  },
}))

export const Logo = styled('span')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  padding: `0 calc(${baseLayout.gridGutterWidth} / 2)`,
  margin: 0,
  overflow: 'hidden',
  backgroundColor: 'transparent',
  [phoneQuery]: {
    display: 'none',
  },
})

export const LogoSmall = styled('span')({
  padding: '0px',
  margin: '0px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  [abovePhoneQuery]: {
    display: 'none',
  },
})

export const HeaderItem = styled('button')(({ theme }) => ({
  height: '40px',
  width: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: 'none !important',
  color: theme.headerItemColor,
  backgroundColor: 'transparent',
  border: '0',
  borderRadius: '10px',
  position: 'relative',
  transition: 'background-color 200ms ease, color 200ms ease',
  '&:hover': {
    color: theme.headerItemColorHover,
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
}))

export const HeaderBtn = styled(List)(({ theme }) => ({
  background: 'transparent',
  color: theme.headerItemColor,
  fontSize: '1.5rem',
  cursor: 'pointer',
  '&:hover': {
    color: theme.headerItemColorHover,
  },
}))

export const LogoImg = styled('img')(() => ({
  width: '100%',
  maxWidth: '150px',

  marginInlineEnd: '70px',
  height: 'auto',
  maxHeight: `calc(${baseLayout.headerHeight} - 20px)`,
  objectFit: 'contain',
}))
